import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { Card } from "../../../components/ui/card";
import { Config } from "../../../utils/config";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";

const stripePromise = loadStripe(Config.env.app.stipe_public_key);

export default function StripePayment({
  clientId,
  email,
  id,
  cartId,
  authToken,
  setCurrentSelected,
  setIsPlaceOrder,
  restaurantDetail,
  setIsHeader,
  setIsOnlinePayment,
  total,
  setCartTotal,
  orderingMethod,
}) {
  const options = {
    clientSecret: clientId,
  };
  return (
    <>
      {clientId && (
        <Elements stripe={stripePromise} options={options}>
          <CheckoutForm
            email={email}
            id={id}
            cartId={cartId}
            authToken={authToken}
            setCurrentSelected={setCurrentSelected}
            setIsPlaceOrder={setIsPlaceOrder}
            restaurantDetail={restaurantDetail}
            setIsHeader={setIsHeader}
            setIsOnlinePayment={setIsOnlinePayment}
            clientSecret={clientId}
            setCartTotal={setCartTotal}
            orderingMethod={orderingMethod}
          />
        </Elements>
      )}
    </>
  );
}
